
import Head from 'next/head';
import { GetServerSideProps, NextPage } from 'next';
import MainLayout from '@layouts/main-layout/main-layout';
import AuthorPage from '@components/blog/author-page/author-page';
import { IAuthor,   } from '@models/author.interface';
import { IArticle } from '@models/article.interface';
import { getAuthor, getAuthors, getAuthorsArticles } from '@services/author.service';
import { getMatchingRedirect } from '@services/redirect.service';
import { ServerSidePropsError } from '@helpers/server-side-props-error.helper';
import { useRouter } from 'next/router';
import { MetaTags } from '@helpers/meta-tags.helper';
import { generateAuthorJsonLd } from '@helpers/generateAuthorJsonLd';
import { toPaginatedMetaText } from '@libs/utils/article.utils';

interface AuthorProps {
    author: IAuthor;
    articles: IArticle[];
    authors:IAuthor[];
    total:number;
    page: number,
}

const LIMIT = 9;


const Author: NextPage<AuthorProps> = ({ author, articles,authors,total,page }) => {
    const { asPath } = useRouter();

    return (
        <>
            <Head>
            {
                    MetaTags({
                        title: author.metaTitle  + ' ' + toPaginatedMetaText(page),
                        description: author.metaDescription + ' ' + toPaginatedMetaText(page,false),
                        pageUrl: asPath,
                        imageUrl: '/blog-images/authors-image-meta.png',
                    })
                }
                     <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(
                        generateAuthorJsonLd(author)
                    )
                }}
            />
            </Head>
            <MainLayout>
                <AuthorPage author={author} articles={articles} authors={authors} total={total} page={page} />
            </MainLayout>
        </>
    );
};

export default Author;

export const getServerSideProps: GetServerSideProps<any | ServerSidePropsError> = async (context) => {
    const authorName = context.query.author as string;
    
    let pageRequest = 0;
    const { data: authorData } = await getAuthor(authorName);
    const { data: authorsData } = await getAuthors();
        
    if (context.query.page) {
        pageRequest = Number(context.query.page) - 1;
    }

    const [articles] = await Promise.all([
        getAuthorsArticles(true, LIMIT * pageRequest, LIMIT, authorName),
    ]);

    const currentPageIsBiggerThanLastPage = articles.total < LIMIT * pageRequest;
   
    if (currentPageIsBiggerThanLastPage) {
        return {
            notFound: true,
        };
    }

    const [url] = context.resolvedUrl.split('?');
    const redirectUrl = await getMatchingRedirect(url);
    if (redirectUrl) {
        return {
            redirect: {
                destination: redirectUrl,
                permanent: true,
            },
        };
    }
    
    if (authorData) {
        return {
            props: {
                author: authorData,
                articles: articles,
                authors:authorsData,
                total: articles.total,
                page: (pageRequest + 1),
            },
        }
    }

    return {
        notFound: true,
    };  
};